import { applyMiddleware, createStore, combineReducers, Action } from "redux";
import thunk from "redux-thunk";

import { logger } from "./middleware/LoggerMiddleware";

const progressReducer = (state: any = {}, action: IAppAction): any => {
  console.log("inside progressReducer", state, action);
  switch (action.type) {
    case "open-progress":
      return { ...state, ...{ isOpen: true } };
    case "close-progress":
      return { ...state, ...{ isOpen: false } };
    default:
      return state;
  }
};

const rootReducer = combineReducers({
  progress: progressReducer
});
const initialState = {
  progress: {
    isOpen : false
  }
};

function configureStore(rootReducer?: any, preloadedState?: any) {
  const middlewares = [logger, thunk];
  const middlewareEnhancer = applyMiddleware(...middlewares);

  const store = createStore(rootReducer, preloadedState, middlewareEnhancer);
  return store;
}

export interface IAppAction extends Action<string> {
  payload?: any;
}

export const store = configureStore(rootReducer, initialState);
